import { SystemMessage } from "@app/constants";
import { CampaignType } from "@app/types";
import * as Yup from "yup";

const baseValidationSchema = {
  type: Yup.number().required(SystemMessage.INPUT_REQUIRED),
  content: Yup.string().required(SystemMessage.INPUT_REQUIRED),
  startDate: Yup.string().nullable(),
  endDate: Yup.string()
    .nullable()
    .test("endDate", "Ngày kết thúc phải sau ngày bắt đầu", function (value) {
      const { startDate } = this.parent;

      if (!startDate || !value) return true;

      return new Date(value) > new Date(startDate);
    }),
};

export const createAffiliateCampaignValidationSchema = Yup.object().shape({
  ...baseValidationSchema,
  book: Yup.object()
    .nullable()
    .when("type", {
      is: CampaignType.GIFT_BOOK,
      then: (schema) => schema.required(SystemMessage.INPUT_REQUIRED),
      otherwise: (schema) => schema.nullable(),
    }),
  kas: Yup.number().when("type", {
    is: CampaignType.GIFT_KAS,
    then: (schema) =>
      schema
        .required(SystemMessage.INPUT_REQUIRED)
        .min(1, "Số kas phải lớn hơn 0"),
    otherwise: (schema) => schema.nullable(),
  }),
  vipTime: Yup.number().when("type", {
    is: CampaignType.GIFT_VIP,
    then: (schema) =>
      schema
        .required(SystemMessage.INPUT_REQUIRED)
        .min(1, "Thời gian VIP phải lớn hơn 0"),
    otherwise: (schema) => schema.nullable(),
  }),
  thumbnail: Yup.string().when("type", {
    is: (val: number) =>
      val === CampaignType.GIFT_KAS || val === CampaignType.GIFT_VIP,
    then: (schema) => schema.required(SystemMessage.INPUT_REQUIRED),
    otherwise: (schema) => schema.nullable(),
  }),
});

export const updateAffiliateCampaignValidationSchema = Yup.object().shape({
  ...baseValidationSchema,
  book: Yup.object()
    .nullable()
    .when("type", {
      is: CampaignType.GIFT_BOOK,
      then: (schema) => schema.required(SystemMessage.INPUT_REQUIRED),
      otherwise: (schema) => schema.nullable(),
    }),
  kas: Yup.number().when("type", {
    is: CampaignType.GIFT_KAS,
    then: (schema) =>
      schema
        .required(SystemMessage.INPUT_REQUIRED)
        .min(1, "Số kas phải lớn hơn 0"),
    otherwise: (schema) => schema.nullable(),
  }),
  vipTime: Yup.number().when("type", {
    is: CampaignType.GIFT_VIP,
    then: (schema) =>
      schema
        .required(SystemMessage.INPUT_REQUIRED)
        .min(1, "Thời gian VIP phải lớn hơn 0"),
    otherwise: (schema) => schema.nullable(),
  }),
  thumbnail: Yup.string().when("type", {
    is: (val: number) =>
      val === CampaignType.GIFT_KAS || val === CampaignType.GIFT_VIP,
    then: (schema) => schema.required(SystemMessage.INPUT_REQUIRED),
    otherwise: (schema) => schema.nullable(),
  }),
});
